import { BodySmall, TitleSmall } from '@shared/components/core/text/Typography';
import { ICoreCardProps } from '@shared/models/components/ICoreCardProps';
import { CardSmall, StatusChip, WrapCardText } from './CommonCardStyles';

const Card: React.FC<ICoreCardProps> = ({ title, description, statusText: statusChip, children }) => {
    return (
        <CardSmall>
            {statusChip && <StatusChip>{statusChip}</StatusChip>}
            <WrapCardText>
                <TitleSmall>{title}</TitleSmall>
                <BodySmall>{description}</BodySmall>
                {children}
            </WrapCardText>
        </CardSmall>
    );
};

export default Card;
